import {
  BasePaginateParamsSchema,
  BasePaginateResultSchema,
} from '@/api/common.ts'
import { z } from 'zod'

export const Inv2210SearchParamsSchema = z
  .object({
    number: z.string().optional(),
    refNo: z.string().optional(),
    dateFrom: z.coerce.date().optional(),
    dateTo: z.coerce.date().optional(),
    dueDateFrom: z.coerce.date().optional(),
    dueDateTo: z.coerce.date().optional(),
    itemId: z.coerce.number().optional(),
    status: z.number().optional(),
    filterStatus: z.string().optional(),
  })
  .merge(BasePaginateParamsSchema)

export type Inv2210SearchParams = z.infer<typeof Inv2210SearchParamsSchema>

export const Inv2210ListItemSummarySchema = z.object({
  itemId: z.number(),
  itemCode: z.string(),
  itemName: z.string(),
  qty: z.number(),
  unit: z.string(),
})

export type Inv2210ListItemSummary = z.infer<
  typeof Inv2210ListItemSummarySchema
>

export const Inv2210SearchResultModelSchema = z.object({
  id: z.number(),
  number: z.string(),
  date: z.coerce.date(),
  partyId: z.number().nullable(),
  refNo: z.string().nullable(),
  refDate: z.coerce.date().nullable(),
  dueDate: z.coerce.date().nullable(),
  remark: z.string().nullable(),
  status: z.union([z.literal(1), z.literal(2), z.literal(3), z.literal(4)]),
  isFulfilled: z.boolean().nullish(),
  confirmed: z.boolean().nullish(),
  items: z.array(Inv2210ListItemSummarySchema),
})

export type Inv2210SearchResultModel = z.infer<
  typeof Inv2210SearchResultModelSchema
>

export const Inv2210SearchResultSchema = z
  .object({
    data: z.array(Inv2210SearchResultModelSchema),
  })
  .merge(BasePaginateResultSchema)

export type Inv2210SearchResult = z.infer<typeof Inv2210SearchResultSchema>

export const Inv2210ItemManualPickSchema = z.object({
  id: z.number(),
  itemId: z.number(),
  itemCode: z.string(),
  itemName: z.string(),
  lotNo: z.string(),
  mold: z.string(),
  lotDate: z.coerce.date(),
  isClaimItem: z.boolean(),
  availableQty: z.number(),
  location: z.string(),
})
export type Inv2210Inv2210ItemManualPick = z.infer<
  typeof Inv2210ItemManualPickSchema
>

export const Inv2210ManualPickResultSchema = z
  .object({
    data: z.array(Inv2210ItemManualPickSchema),
  })
  .merge(BasePaginateResultSchema)
export type Inv2210ManualPickResult = z.infer<
  typeof Inv2210ManualPickResultSchema
>
